import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Pesticide, PesticideData } from '../../customs/_models/ProductPesticideMRL';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PesticideService {

  private apiUrl =  `${environment.base_url}/substance`;  // URL de l'API Spring Boot

  constructor(private http: HttpClient) { }

  // Méthode pour obtenir les informations de la substance active par numéro CAS
  getSubstanceInfo(casNumber: string): Observable<any> {
    const params = new HttpParams().set('casNumber', casNumber);  // Paramètre de la requête GET
    return this.http.get(this.apiUrl, { params });  // Requête GET avec les paramètres
  }
  
    private apiUrl1 = `${environment.base_url}/api/mrls`;

  getAll(): Observable<PesticideData[]> {
    return this.http.get<PesticideData[]>(this.apiUrl1);
  }
}
